import SubcategoryPage from '@/components/template/SubcategoryPage';

const SarongStool = () => {
  const products = [
    {
      title: "Sarong Stool Natural",
      imageSrc: "https://images.unsplash.com/photo-1616486029423-aaa4789e8c9a?auto=format&fit=crop&q=80",
      url: "/proizvodi/sarong-stool-natural"
    },
    {
      title: "Sarong Stool Modern",
      imageSrc: "https://images.unsplash.com/photo-1581539250439-c96689b516dd?auto=format&fit=crop&q=80",
      url: "/proizvodi/sarong-stool-modern"
    },
    {
      title: "Sarong Stool Ethnic",
      imageSrc: "https://images.unsplash.com/photo-1533090161767-e6ffed986c88?auto=format&fit=crop&q=80",
      url: "/proizvodi/sarong-stool-ethnic"
    }
  ];

  return (
    <SubcategoryPage
      title="Sarong Stool"
      description="Eksotični Sarong stolčki, ki združujejo tradicionalno obrt in sodobni dizajn za edinstven dodatek vašemu domu."
      heroImage="https://images.unsplash.com/photo-1616486029423-aaa4789e8c9a?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default SarongStool;